var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIllustration = function SvgIllustration(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 230",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "92.607%",
    x2: "19.476%",
    y1: "21.008%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#004973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0771AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CBAB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E3BF80"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 106.297,
    cy: 106.27,
    r: 105.901
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 8.901,
    cy: 134.177,
    r: 109.298
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-78.129 -.086)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.052 17.327)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "#FFFDF8"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 31.102,
    cy: 132.976,
    r: 87.648,
    fill: "#FFF",
    mask: "url(#b)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.102,
    cy: 132.976,
    fill: "#FFF",
    mask: "url(#b)",
    opacity: 0.8,
    rx: 56.091,
    ry: 55.994
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#e)",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.13 154.672c-45.964 0-121.374-11.913-156.13-11.913v85l218.077-7.135v-66.822q-15.983.87-61.947.87"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E3BF80",
    d: "M200.86 146.58c1.253-1.466 3.574-18.185 6.96-39.166v-26.4q.778-2.043 4.49 14.601 5.862-.145 8.48 4.8 2.616 4.947-5.779 11.542c-2.235 31.875-4.632 54.59-7.19 57.155-7.613.55-31.38-23.344-32.192-24.73-1.09-1.86 0-11.542-6.187-22.689-.791-1.424 11.554-2.413 13.331 0 1.778 2.414 15.132 22.688 18.087 24.887"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M206.311 169.112c-9.547-2.628-30.052-23.655-30.682-24.73-1.09-1.86 32.19 21.71 30.682 24.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m133.109 110.368 6.941-.847 2.941-12.4 11.232-1.022h3.697l-.397 11.744 3.622-.217 9.389 26.927q-19.618 3.306-20.992 3.307c-1.375 0-8.331-10.107-9.492-11.431q-1.16-1.325-6.941-16.061",
    transform: "rotate(-4 359.713 11.272)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77CE4E",
    d: "M140.539 220.061c1.33-9.082 4.144-22.364 3.39-33.137-1.01-14.45-6.492-25.323-10.626-31.901q-19.249-21.166 7.958-29.127 16.688 19.824 26.366 19.147t-1.286-23.636q12.131-2.112 14.611-1.07t6.266 7.635q-3.585 3.4-3.373 3.908 2.157 5.19 3.704 8.356c7.85 16.078 9.876 18.48.576 27.14-5.352 13.827-3.29 29.764-2.138 36.909s2.384 13.992 7.473 24.792c-10.102 1.016-20.453.026-27.12-1.078-9.861-1.634-18.862-4.72-25.801-7.938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M143.924 188.65c-1.01-14.45-6.487-27.05-10.62-33.627-5.74-2.94-.142-11.614 6.521-3.819 1.868 2.185 2.608 11.624 4.681 15.584 9.469 18.088 20.114 6.978 20.269 12.114.136 4.491-3.668 9.704-5.084 14.94-2.226 9.344-3.548 24.521-3.548 31.856-1.222-.256-10.402-3.072-15.607-5.674 1.17-7.767 3.942-23.453 3.388-31.375z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3BF80",
    d: "M93.645 191.272c-.674-3.179 13-25.115 33.143-57.198 10.093-.528 12.96 13.37 11.553 16.786-.612 1.487-23.431 33.533-25.721 36.237.91 1.8 19.64 11.407 24.812 13.152 2.597.875 4.009-5.557 6.948-5.71 1.815-.096-1.106 5.87.864 7.306 3.389 2.47 13.029-.013 10.405 9.622q-2.625 9.633-18.742-.733c-30.262-9.936-42.48-15.138-43.262-19.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76CD4D",
    d: "M120.713 143.724q3.908-6.31 6.075-9.65c10.093-.528 13.316 12.983 11.91 16.398q-.132.317-4.218 6.347-3.7-6.366-6.322-8.942t-7.445-4.153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3BF80",
    d: "M162.487 115.647c10.708 1.201 10.785-18.718 7.371-32.408s-13.066-19.146-22.61-16.767-16.347 22.159-12.934 35.849 17.465 12.124 28.173 13.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D3031",
    d: "M159.194 70.451q-17.068 15.8-11.022 39.847c6.045 24.048-8.255 10.924-20.418 22.905a890 890 0 0 0-8.805 13.343l-.353-3.447q-4.299-101.488 42.958-82.02c13.837 5.7 18.324 20.925 19.707 34.538.783 7.709-.362 17.166-1.954 24.373q-1.924.358-14.563 1.738l-.219-6.132q2.998-.753 4.69-3.417c.672-1.56 2.497-8.042 2.455-14.937-.046-7.447-2.038-15.374-3.465-18.047q-3.687-6.907-9.01-8.744z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFD",
    d: "M242.76 6.182A17.2 17.2 0 0 1 255.52.555c8.152 0 14.978 5.627 16.75 13.18 9.231-3.967 20.352-1.55 26.993 6.589a22.7 22.7 0 0 1 3.816 6.755 13.9 13.9 0 0 1 3.478.346c7.374 1.69 11.972 8.991 10.27 16.309-1.703 7.317-9.061 11.88-16.435 10.19a14 14 0 0 1-.604-.152 17.06 17.06 0 0 1-9.551 13.423 17.3 17.3 0 0 1-16.526-.787c-4.506 7.506-14.084 10.446-22.1 6.537a17 17 0 0 1-5.756-4.562 17.29 17.29 0 0 1-15.067-.005 17.06 17.06 0 0 1-9.618-14.133c-7.08.456-13.653-4.228-15.3-11.31-1.832-7.873 3.114-15.728 11.047-17.545a15 15 0 0 1 3.156-.378 16.93 16.93 0 0 1 3.61-13.47c4.703-5.762 12.41-7.69 19.076-5.36zm-51.294 67.232a2.914 2.914 0 1 1 0-5.828 2.914 2.914 0 0 1 0 5.828m6.914-9.035a5.813 5.813 0 1 1 0-11.625 5.813 5.813 0 0 1 0 11.625"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.673,
    cy: 37.615,
    fill: "#EBF0F5",
    rx: 12.544,
    ry: 12.564
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F5",
    d: "M263.129 30.115h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m0 10h28a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-28a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76CD4E",
    fillRule: "nonzero",
    d: "m244.695 32.672-6.203 6.214-1.841-1.844a1.445 1.445 0 0 0-2.045 0 1.45 1.45 0 0 0 0 2.048l3.886 3.892 8.249-8.262a1.45 1.45 0 0 0 0-2.048 1.445 1.445 0 0 0-2.046 0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIllustration);
export default ForwardRef;